exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.mobile-mytasks-container{overflow-x:hidden;overflow-y:auto;height:100%;-webkit-overflow-scrolling:touch}.mobile-mytasks-container .empty-tasks{display:flex;align-items:center;flex-direction:column;justify-content:center;height:68%}.mobile-mytasks-container .empty-tasks__description{color:#9b9b9b;font-family:Open Sans,sans-serif;font-size:16px;margin-top:18px;text-align:center;margin-left:30px;margin-right:30px}.mobile-mytasks-container .empty-tasks__description2{color:#9b9b9b;font-family:Open Sans,sans-serif;font-size:16px;text-align:center;padding:0;margin:0;margin-left:30px;margin-right:30px}.mobile-mytasks-container .empty-tasks__image{width:33%;margin-left:3%}.mobile-mytasks-container .empty-tasks__indicator{margin-bottom:-3px}.mobile-mytasks-container .offline-no-tasks{display:flex;align-items:center;flex-direction:column;justify-content:center;height:100%;width:100vw}.mobile-mytasks-container .offline-no-tasks__image{width:33%;margin-left:3%}.mobile-mytasks-container .offline-no-tasks__description{color:#9b9b9b;font-family:Open Sans,sans-serif;font-size:24px;margin-top:32px;font-weight:600;text-align:center}.mobile-mytasks-container::-webkit-scrollbar{width:0!important;display:none!important}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/ProjectDetailsContainer/MobileMyTasks/MobileMyTasks.scss
// module id = 1778
// module chunks = 0